import { render, staticRenderFns } from "./ContentRequeriments.vue?vue&type=template&id=36cf308a&scoped=true"
import script from "./ContentRequeriments.vue?vue&type=script&lang=js"
export * from "./ContentRequeriments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf308a",
  null
  
)

export default component.exports